import { Component, Input, SimpleChanges } from '@angular/core';
import { ButtonVariant } from '@shared/components';

@Component({
	selector: 'drop-zone',
	templateUrl: './drop-zone.component.html',
	styleUrl: './drop-zone.component.scss',
	standalone: false,
})
export class DropZoneComponent {
	@Input() placeholder: string = 'Drag and drop a file here or click to upload';
	@Input() width: number = 300;
	@Input() height: number = 300;
	@Input() type: 'file' | 'img' = 'file';
	@Input() defaultImg?: string;
	public readonly: boolean = true;
	public hasImageError: boolean = false;

	public isDragging: boolean = false;
	public fileList: File[] = [];

	public buttonVariantEnum = ButtonVariant;

	onDragOver(event: DragEvent) {
		event.preventDefault();
		this.isDragging = true;
	}

	onDragLeave(event: DragEvent) {
		event.preventDefault();
		this.isDragging = false;
	}

	onDrop(event: DragEvent) {
		event.preventDefault();
		this.isDragging = false;
		if (event.dataTransfer?.files.length) {
			this.appendFiles(event.dataTransfer.files);
		}
	}

	onFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input.files?.length) {
			this.appendFiles(input.files);
		}
	}

	triggerFileInput(fileInput: HTMLInputElement) {
		fileInput.click();
	}

	appendFiles(fileList: FileList) {
		for (let i = 0; i < fileList.length; i++) {
			this.fileList.push(fileList[i]);
		}
	}

	removeFile(index: number, event: MouseEvent) {
		event.stopPropagation();
		this.fileList.splice(index, 1);
	}

	isImage(file: File): boolean {
		return file.type.startsWith('image/');
	}

	getObjectURL(file: File): string {
		return URL.createObjectURL(file);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['defaultImg']) {
			this.hasImageError = false;
		}
	}
}
